import grapesjs from "grapesjs";
import gjsBlockBasic from "grapesjs-blocks-basic";
import grapesJsexportPlugin from "grapesjs-plugin-export";
import grapesJsFormsPlugin from "grapesjs-plugin-forms";
import gjsTabs from "../../components/ComponentsTabs/index.js";
import gjsTable from "grapesjs-table";
//import gjsForm from "grapesjs-plugin-forms";
import "../../css/editor.scss";
import "../../css/grapesjs.scss";
import UnlockIcon from "../../images/unlock-icon-toolbar.svg";
import LockIcon from "../../images/lock-icon-toolbar.svg";
import { moduleApiEndPoint } from "../../services/axiosConfig";
import {
  defaultBlocks,
  styleManager,
  blocks,
  thirdPartyPlugins,
  script,
  mandatScript,
} from "../../utils/editorUtils/editorUtils";
import { ExportDeckToMail, getFontlist } from "../../services/apis";
import { cutomTraitsLinkPlugin } from "./customLinkBlock/cutomTraitsLinkPlugin.js";
import { attachMasterSlide } from "./customScriptBlock.js"
import { gereratePluginsList } from "./generatePluginsList.js"
import { EditorOnLoad } from "./EditorOnLoad.js"
import { UpdateHTMLForAllRatios } from "./ResponsiveFunctions.js"
import { showErrorToast, showSuccessToast } from "../../components/toastComponent/ToastComponent.js";
import { callbackOnDeselectOfComp, defaultConfigForAllComp, hideGeneralAndTopographyForWrapper, leftPanelBlocksHideShow, linkComponent, hideModularContentForBodyTag, modularContentToggleShow, onCompSelectConfig, opacityFieldRestrictDecimal, removeCompSettingRetainDefault, removePopupDivLinkedToComp, tableConfig, tableRowColumnDecimalRestriction, trackDroppingComponent, videoConfig } from "../editorUtils/componentConfig.js"
import { customTigger } from "./customPopup/CustomTrigger.js"
import { aspectRatioCheckBoxHandler } from "./aspectRatio.js";
import { keycloak } from "../../services/keycloak.js";
let plugList = [];
let Flag = false
function getGrapeJsEditor({
  currentSlideRef,
  setState,
  setVideoSelected,
  setShowPreView,

  setSaveLoading,
  setLoading,
  setLoadSuccess,
  setExportLoading,

  showSlidesPanel,

  setOpenExportModal,
  localLink,
  switchToggleDataRef,
  setRedoCurrentStatus,
  setReferenceBetween,

  setAddReferenceBlock,
  setUploadFont,
  appData,
  setOpenDocumentModal,
  setExpandRight,
  setExpandLeft,
  selectedItem,
  setCSSState,
  cssRef,
  storageObjRef,
  setStorageObj,
  listOfIDRef,
  setListOfID,
  codeEditor,
  setDimensionVariable

}) {
  let cssLink = [];
  if (localStorage.getItem('cssglobalUrl')) {
    cssLink.push(localStorage.getItem('cssglobalUrl'))
  } else {
    cssLink.push(appData?.deckId?.deck_shared_assets?.global?.css?.url)
  }


  if (!plugList.length)
    plugList = gereratePluginsList()

  // if (isOpenPanel) {
  if (
    document.getElementById("blocks") ||
    document.getElementById("stylesMangerBlock") ||
    document.getElementById("editor-actions-btns") ||
    document.getElementById("traitBlock") ||
    document.getElementById("layerHtml")

  ) {
    document.getElementById("blocks").innerHTML = "";
    document.getElementById("stylesMangerBlock").innerHTML = "";
    document.getElementById("editor-actions-btns").innerHTML = "";
    document.getElementById("traitBlock").innerHTML = "";
    document.getElementById("layerHtml").innerHTML = "";

  }
  const blockContainer = document?.querySelector("#blocks");
  const styleContainer = document?.querySelector("#stylesMangerBlock");
  const traitsContainer = document?.querySelector("#traitBlock");
  const backtoBlockSection = document?.querySelector("#backToBlocks");

  let IDRef =
    JSON.stringify(currentSlideRef?.current?.child) === "{}"
      ? currentSlideRef?.current?.master?.slideid?._id
      : currentSlideRef?.current?.child?.slideid?._id;

  const popupCloseButtonType = (editor) => {  
    // Component: popup-close-button
    editor.Components.addType("popup-close-button", {
      model: {
        defaults: {
          tagName: "button",
          type: "link",
          components: [
            {
              tagName: "p",
              content: "Close",
              style: {
                margin: '0',
              }
            },
          ],
          attributes: {
            class: "popup-close close",
            'data-close-popup': 'true',
            'data-gjs-highlightable': 'true',
          },
          style: {
            "min-width": "50px",
            "min-height": "50px",
            position: "absolute",
            top: "0px",
            right: "0px",
            border: "none",
            cursor: "pointer",
          },
          traits: [],
        },
      },

    });
  }
  const customPopupBlocktype = (editor) => {
    editor.Components.addType("custom-popup", {
      model: {
        defaults: {
          tagName: "div",
          name: "Custom Popup",
          popupId: "popup-1",
          traits: [
            {
              type: "text",
              label: "Popup ID",
              name: "popupId",
              changeProp: 1,
            },
          ],
          attributes: {
            id: "popup-1",
            class: "gjs-popup",

          },
          droppable: false,
          components: [
            {
              tagName: "div",
              attributes: { class: "popup-overlay" },
              components: [
                {
                  tagName: "div",
                  attributes: { class: "popup-content" },
                  components: [
                    {
                      type: "text",
                      content: "This is a popup!",
                    },
                    {
                      type: "popup-close-button",
                    },
                  ],
                },
              ],
            },
          ],
          styles: `
          .gjs-popup {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: none;
            z-index: 9999;
          }
          .popup-overlay {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }
          .popup-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            min-width: 300px;
            box-shadow: 0 0 10px rgba(0,0,0,0.3);
          }
          .popup-close {
            padding: 8px 16px;
            background-color: #dc3545;
            color: #fff;
            border: none;
            border-top-right-radius: 8px;
            border-bottom-left-radius: 8px;
            cursor: pointer;
          }
          .popup-close:hover {
            background-color: #c82333;
          }
        `,
        },
        init() {
          this.on("change:popupId", () => {
            const id = this.get("popupId");
            this.addAttributes({ id });
            // registerPopupId(id);
          });
        },
      },
    });
  }

  const editor = grapesjs.init({
    panels: {
      defaults: [
        {
          id: "editor-actions-btns",
          el: ".panel__editor-btns",

          buttons: [
            //
            // {
            //   id: "cmd-clear",
            //   className: "edDeleteIcon",
            //   command: "cmd-clear",
            // },
            // {
            //   id: "undo",
            //   className: "edUndoIcon",
            //   command: "undo",
            // },
            // {
            //   id: "redo",
            //   className: "edRedoIcon",
            //   command: "redo",
            // },
            // {
            //   id: "export",
            //   // className: "edExportIcon",
            //   command: "export",
            // },
            // {
            //   id: "saveDb",
            //   className: "edSaveIcon",
            //   command: "saveDb",
            // },
            // {
            //   id: "preview",
            //   className: "edPreviewIcon",
            //   command: "preview",
            // },
            {
              id: "visibility",
              active: true, // active by
              className: "edGridIcon",
              // label: "<u>B</u>",

              command: "sw-visibility",
            },
          ],
        },
      ],
    },
    container: "#gjsEditor",
    blockManager: defaultBlocks,
    styleManager: styleManager,
    allowScripts: true,
    keepUnusedStyles: true,
    forceClass: true,
    dragMode: "translate",
    // styleManager: { appendTo: "#stylesMangerBlock" },
    // pageManager: {
    //   appendTo: "#PageManager",
    // },
    protectedCss: "",
    // style: `
    // body{font-family: 'Calibri', sans-serif !important; overflow:hidden;}
    // `,
    //projectData: projectData,
    //storageManager: true,

    storageManager: {
      type: "remote",
     // stepsBeforeSave: 5,
       stepsBeforeSave: 1,
      contentTypeJson: true,
      storeComponents: true,
      storeStyles: true,
      storeHtml: true,
      storeCss: true,
      id: "mycustom-",
      options: {
        remote: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
          fetchOptions: (opts) =>
            opts.method === "POST" ? { method: "PATCH" } : {},
          urlLoad: `${moduleApiEndPoint}slides/${IDRef}`,
          urlStore: `${moduleApiEndPoint}slides/${IDRef}`,
          onStore: (data) => {
            // calculate slide number and mlrstatus
            let master = currentSlideRef?.current?.master;
            let children;
            // const mlrStatus = appData?.deckId?.veevaMetadata?.filter((asset) => asset.assetType === 1)[0].docStatus;        
            if (currentSlideRef?.current?.child === "{}") {
              master = currentSlideRef?.current?.master;
            } else {
              children = currentSlideRef?.current?.master?.children?.filter(l => l?.slideid === currentSlideRef?.current?.child?.slideid)[0];
            }
            let ID =
              JSON.stringify(currentSlideRef?.current?.child) === "{}"
                ? currentSlideRef?.current?.master?.slideid?._id
                : currentSlideRef?.current?.child?.slideid?._id;
            // if (appData.deckId.type === 1)
            //updateModularContenforMM(editor, ID, appData);
            
            let pophtml= editor?getPopUp(editor):'';
            if (!appData.deckId.default_aspect_ratio) {
              let cssString = `@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
${editor?.getCss() +
"body{ width:1024px; height:768px;}" ||""}
[data-slide-id]{cursor:pointer}.tab{cursor:pointer}`;
              let content = {
                editorData: JSON.stringify(data) || "",
                html: editor?.getHtml() || "",
                css: cssString,
                // components: editor.getComponents() || "",
                // styles: editor.getStyle() || "",
                scripts: script,
                  // editor?.getWrapper()?.find("[ccid]").length > 0
                  //   ? script
                  //   : mandatScript,
                thirdPartyPlugins: thirdPartyPlugins,
                extraContent:pophtml,

                //modalBgColor: editor.getWrapper().getStyle()["background-color"],
              };
              return {
                content: content,
                // mlrStatus: mlrStatus,
                // slideNumber: children ? Number(`${master}.${children}`) : master
                thumbnail: children ? children?.slideid?.thumbnail : master?.slideid?.thumbnail
              };
              // setSaveLoading(true);
            } else {
              let content = savingResponsiveData({ storageObjRef, appData, selectedItem, cssRef, editor, data, setStorageObj });
              //if (!storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData)
              content = UpdateHTMLForAllRatios({ editor, appData, content, storageObjRef, setStorageObj, selectedItem, listOfIDRef })
              return {
                content: content,
                thumbnail: children ? children?.slideid?.thumbnail : master?.slideid?.thumbnail
              };
            }
          },
          onLoad: (result) => {
            setVideoSelected(false);
            let x =
              JSON.stringify(currentSlideRef?.current?.child) !== "{}"
                ? currentSlideRef.current.child
                : currentSlideRef.current.master;

            const assignSlideNameNKeyMessageToId = (ids, obj) => {
              ids.slideid.key_message =
                ids?.slideid?.key_message || "Enter Key Message";
            };
            // setCurrentSlide({ master: x, child: {} });
            //  currentSlideRef?.current.master = x;
            if (x && JSON.stringify(x) !== "{}") {
              assignSlideNameNKeyMessageToId(x, result);

              // let tempSlideID = [
              //   ...slideID,
              //   (slideID[x.index - 1] = currentSlideRef?.current?.master),
              // ];
              // let array = tempSlideID.filter(
              //   (value, index, self) =>
              //     index ===
              //     self.findIndex((t) => t?.slideid?._id === value?.slideid?._id)
              // );
              //setSlideID(array);
            }
            setStorageObj(result.content)
            setTimeout(() => {
              setLoading(false)
            }, 1000);

            if (false && result?.content?.[selectedItem]) {
              return JSON.parse(result?.content?.[selectedItem]?.editorData || result?.content?.editorData);
            } else {

              return JSON.parse(result?.content?.editorData || "{}");
            }
            //return JSON.parse(result?.content?.editorData || "{}");
          },
        },
      },
    },
    layerManager: {
      // If the `root` is not specified or the component element is not found,
      // the main wrapper component will be used.
      appendTo: '#layerHtml',
      custom: true,
      sortable: true,
      hidable: true,
    },
    assetManager: {
      // ...
      types: ['image'],
      custom: {
        open(props) {
          setState(true);
        },
        close(props) { },
      },
    },
    style: `
    body{background-color:#fff;margin:0; width:1024px; height:768px;  }
     *{box-sizing: border-box;} input, textarea, select {border-width: 1px; border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133)); border-style: inset;}
  .modal{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6)}
      .modal-content{margin:0;height:100%;width:100%;padding:0;}.close{position:absolute;right:0;}iframe.modal-iframe{height:100%;width:100%;border:0;margin-top:0px;}[data-slide-id]{cursor:pointer}`,
    canvas: {
      // style: localScripts,
      scripts: localLink,
      styles: cssLink
    },

    traitManager: {
      appendTo: "#traitBlock",
    },
    selectorManager: {
      appendTo: "#stylesMangerBlock",
      custom: true,
    },

    plugins: [
      cutomTraitsLinkPlugin,
      //customType, //Imported for smart template feature classic/Modular toggele
      //commonHtmlType, //common html toggle and feature can be enable
      "gjs-blocks-basic",
      grapesJsexportPlugin,
      gjsTabs,
      //gjsTable,
      (editor) =>
        gjsTable(editor, {
          tableBlock: {
            label: "Table",
            category: "",
            activate: false,
          },

          tableProps: {
            rows: 3,
            columns: 3,
            header: false,
            footer: false,
            editable: 1,
            unstylable: [
              // "display",
              "transform",
              "transition",
              "perspective",
              "modular_content",
            ],
          },
        }),
      // grapesjsrteextensions,
      // (editor) =>
      //   gjsForm(editor, {
      //     blocks: ["select", "form"],
      //     container: "#gjsforms",
      //   }),
      (editor) =>
        grapesJsFormsPlugin(editor, {
          formBlock: {
            label: "Forms",
            category: "form",
            activate: false,
          },
        }),
        popupCloseButtonType,
        customPopupBlocktype,
        customTigger,
    ],

    pluginsOpts: {
      "gjs-blocks-basic": {
        // Which blocks to add'
        // stylePrefix: "", // no gjs- prefix

        blocks: blocks,
        flexGrid: 1,
      },
      // "grapesjs-rte-extensions": {
      //   // default options
      //   base: {
      //     bold: true,
      //     italic: true,
      //     underline: true,
      //     strikethrough: true,
      //     link: true,
      //   },
      //   subscriptSuperscript: true,
      //   //fonts: {
      //   //  fontName: ['font1',...,'fontn'],
      //   //  fontSize: true,
      //   //  //An array of strings representing colors
      //   //  fontColor: ['#fff',...],
      //   //  //An array of strings representing colors
      //   //  hilite: ['#fff',...],
      //   //}
      //   fonts: {
      //     fontColor: true,
      //     hilite: true,
      //   },
      //   format: {
      //     heading1: true,
      //     heading2: true,
      //     heading3: true,
      //     //heading4: false,
      //     //heading5: false,
      //     //heading6: false,
      //     paragraph: true,
      //     //quote: false,
      //     clearFormatting: true,
      //   },
      //   //|true
      //   indentOutdent: true, //|true
      //   list: false, //|true
      //   align: true, //|true
      //   //actions: {
      //   //  copy: true,
      //   //  cut: true,
      //   //  paste: true,
      //   //  delete: true,
      //   //},
      //   actions: false, //|true
      //   undoredo: false, //|true
      //   extra: false, //|true
      //   darkColorPicker: true, //|false
      //   maxWidth: "600px",
      // },

      //gjsTabs: {},
      //gjsTable: {},
      //gjsForm: { blocks: formblocks },
    },

    showDevices: false,
    showPreview: false,
    //showToolbar: false,
    devicePreviewMode: false,
  });
  window.editor = editor;
  //editor.getModel().set("dmode", "absolute");
  // editor.getModel().set("dmode", "absolute");
  
  // Automatic width assignment and resizable from all sides: Column blocks and rows get 50% width by default
  const setColumnBlockWidth = (component) => {
    if (!component) return;
    
    // Check if it's a column/cell block from gjs-blocks-basic
    const componentType = component.get('type');
    const componentClasses = component.get('classes');
    const parent = component.parent();
    
    // Check for row components (.gjs-row)
    const isRow = 
      componentType === 'row' || 
      (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
        const className = cls.get('name') || '';
        return className === 'gjs-row';
      }));
    
    // Column blocks are typically 'cell' type or have specific classes
    const isColumnBlock = 
      componentType === 'cell' || 
      (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
        const className = cls.get('name') || '';
        return className.includes('gjs-f-b') || 
               className.includes('column') || 
               className === 'gjs-cell';
      })) ||
      (parent && parent.get('type') === 'row');
    
    if (isColumnBlock || isRow) {
      // Set default width to 50% if not already set
      const currentWidth = component.getStyle('width');
      if (!currentWidth || currentWidth === 'auto' || currentWidth === '' || currentWidth === '0px') {
        setTimeout(() => {
          if(!component.getStyle('width') || component.getStyle('width') === 'auto') {
            component.addStyle({ width: '50%' });
          }
        }, 10);
        /* setTimeout(() => {
          component.addStyle({ width: '50%' });
        }, 10); */
      }
      
      // Enable resizable from all sides
      setTimeout(() => {
        component.set('resizable', {
          tl: 1, // top-left
          tc: 1, // top-center
          tr: 1, // top-right
          cl: 1, // center-left
          cr: 1, // center-right
          bl: 1, // bottom-left
          bc: 1, // bottom-center
          br: 1, // bottom-right
          ratioDefault: false,
          minDim: 50, // minimum dimension
        });
      }, 10);
    }
  };

  // Set width when component is added
  editor.on('component:add', (component) => {
    setColumnBlockWidth(component);
  });

  // Also set width when component is updated
  editor.on('component:update', (component) => {
    setColumnBlockWidth(component);
  });

  // Set width when component is selected (in case it was missed)
  editor.on('component:selected', (component) => {
    setColumnBlockWidth(component);
    
    // Ensure resizable is enabled from all sides when selected
    const componentType = component.get('type');
    const componentClasses = component.get('classes');
    const parent = component.parent();
    
    const isRow = 
      componentType === 'row' || 
      (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
        const className = cls.get('name') || '';
        return className === 'gjs-row';
      }));
    
    const isColumnBlock = 
      componentType === 'cell' || 
      (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
        const className = cls.get('name') || '';
        return className.includes('gjs-f-b') || 
               className.includes('column') || 
               className === 'gjs-cell';
      })) ||
      (parent && parent.get('type') === 'row');
    
    if (isColumnBlock || isRow) {
      component.set('resizable', {
        tl: 1, tc: 1, tr: 1,
        cl: 1, cr: 1,
        bl: 1, bc: 1, br: 1,
        ratioDefault: false,
        minDim: 50,
      });
    }
  });
  
  let clickedSaveBtn = false;
  const fontlist = editor.StyleManager.getProperty("typography", "font-family");
  const hideFormsBlockss = document?.querySelector(".gjs-block-categories")
    ?.childNodes[1];
  hideFormsBlockss?.classList.add("d-none", "forms-field-block");

  // delete br tag after image is deleted
  editor.on('component:remove', (component) => {
    if (component.get('type') === 'image') {
      const parent = component?.parent();
      if (!parent) return;

      // Defer the cleanup until after the image is removed
      setTimeout(() => {
        parent?.components().forEach(child => {
          const isBrTag = child?.get('tagName') === 'br';
          if (isBrTag) {
            child.remove();
          }
        });
      }, 0);
    }
  });

  editor.on('component:drag:end', (comp) => {

    if(selectedItem==="dim_1024*768" || selectedItem==="dim_2752*2064" || selectedItem==="dim_2388*1668" || selectedItem==="dim_2048*1536") {

      const value = comp.target.getStyle().transform;
      const selectedElement = cssRef.current[selectedItem].find(obj => obj.id === editor.getSelected()?.ccid);
      let allElement=[...cssRef.current[selectedItem]];
      if (!selectedElement){
        allElement.push({id:editor?.getSelected()?.ccid, transform: value})
      }else{
        allElement = allElement.map(o => o.id === selectedElement.id ? {...o, transform: value } : o);
      }
      let allDimensions = {...cssRef.current,[selectedItem]:allElement};
      setCSSState(allDimensions)
      cssRef.current = allDimensions
    }
  });

  let translateX = false, translateY =false;
  editor.on('style:property:update', (sector, test) => {
    if(selectedItem==="dim_1024*768" || selectedItem==="dim_2752*2064" || selectedItem==="dim_2388*1668" || selectedItem==="dim_2048*1536" ) {
      if(sector.property.attributes.property === "name" ) {
        translateY = sector.property.attributes.value === "translateY";
        translateX = sector.property.attributes.value === "translateX";
        return;
      }

      const getTransformValue = () => {
        const comp = editor.getSelected();
        if (!comp) return;

        let transform = comp.getStyle().transform || '';

        if (translateX) {
          transform = transform.includes('translateX')
            ? transform.replace(/translateX\(\s*-?\d*\.?\d+(px|%|em|rem|vh|vw)\s*\)/, `translateX(${sector.value})`)
            : `${transform} translateX(${sector.value})`;
        }
        if (translateY) {
          transform = transform.includes('translateY')
            ? transform.replace(/translateY\(\s*-?\d*\.?\d+(px|%|em|rem|vh|vw)\s*\)/, `translateY(${sector.value})`)
            : `${transform} translateY(${sector.value})`;
        }

        return transform;
      }

      if(sector.value) {
        const selectedElement = cssRef.current[selectedItem].find(obj => obj.id === editor.getSelected()?.ccid);
        let allElement=[...cssRef.current[selectedItem]];

        if (!selectedElement){
          
          let obj={
            id:editor?.getSelected()?.ccid,
            // property:sector.property.id,
            [sector.property.attributes.property]:sector.value
          }
          if(sector.property.attributes.property == "value") {
            let transform = getTransformValue();
            delete obj?.value;
            obj.transform = transform.trim();
          }
          allElement.push(obj)
        }else{
        
          let obj= {[sector.property.attributes.property]:sector.value}
          if(sector.property.attributes.property == "value") {
            let transform = getTransformValue();
            delete obj?.value;
            obj.transform = transform.trim();
          }
          allElement = allElement.map(o => o.id === selectedElement.id ? {...o, ...obj } : o);
        }
        let allDimensions = {...cssRef.current,[selectedItem]:allElement}
        setCSSState(allDimensions)
        cssRef.current = allDimensions;
      }
    }
  }); 
  //commented it on Siva's ask for dimen fix
  /* editor.on('style:property:update', (sector, test) => { 
    if (selectedItem==="dim_1024*768" &&  sector.value){
      const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
      let arrObj=[];
      if (!resultEdObject){
        
        let obj={id:editor?.getSelected()?.ccid,
                // property:sector.property.id,
                [sector.property.id]:sector.value}
        arrObj.push(obj)
      }else{
       
        let obj= {[sector.property.id]:sector.value}
        //resultEdObject
        arrObj.push({...resultEdObject, ...obj})
      }
     let obj2= {...cssRef.current,"dim_1024*768":arrObj}
        setCSSState(obj2)
        cssRef.current=obj2

    }else if (selectedItem==="dim_2752*2064" &&  sector.value){
        const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
        let arrObj=[];
        if (!resultEdObject){
        
          let obj={id:editor?.getSelected()?.ccid,
                  // property:sector.property.id,
                  [sector.property.id]:sector.value}
          arrObj.push(obj)
        }else{
          
          let obj= {[sector.property.id]:sector.value}
          //resultEdObject
          arrObj.push({...resultEdObject, ...obj})
        }
        let obj2= {...cssRef.current,"dim_2752*2064":arrObj }
        setCSSState(obj2)
        cssRef.current=obj2
     
    }else if(selectedItem==="dim_2388*1668" && sector.value){
    
        const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
          let arrObj=[];
          if (!resultEdObject){
        
            let obj={id:editor?.getSelected()?.ccid,
                    // property:sector.property.id,
                    [sector.property.id]:sector.value}
            arrObj.push(obj)
          }else{
     
             let obj= {[sector.property.id]:sector.value}
             //resultEdObject
              arrObj.push({...resultEdObject, ...obj})
           }
           let obj2= {...cssRef.current,"dim_2388*1668":arrObj }
           setCSSState(obj2)
           cssRef.current=obj2
    }else if(selectedItem==="dim_2048*1536" && sector.value){
    
      const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
        let arrObj=[];
        if (!resultEdObject){
      
          let obj={id:editor?.getSelected()?.ccid,
                  // property:sector.property.id,
                  [sector.property.id]:sector.value}
          arrObj.push(obj)
        }else{
   
           let obj= {[sector.property.id]:sector.value}
           //resultEdObject
            arrObj.push({...resultEdObject, ...obj})
         }
         let obj2= {...cssRef.current,"dim_2048*1536":arrObj }
         setCSSState(obj2)
         cssRef.current=obj2
  }
    
  }); 
 */
  editor.Commands.add("set-device-desktop", {
    run: (editor) => editor.setDevice("Desktop"),
  });
  editor.Commands.add("set-device-mobile", {
    run: (editor) => editor.setDevice("Mobile"),
  });

  // editor.Commands.add('core:paste', editor => {
  //  // const selected = editor.getSelected();
  //   debugger;
  // });
  // editor.on("rteToolbarPosUpdate", (pos) => {
  //   if (pos.top <= pos.canvasTop) {
  //     pos.top = pos.elementTop + pos.elementHeight;
  //   }
  // });
  // Save Button
  editor.Commands.add("saveDb", {
    run: async (editor, sender) => {
      setSaveLoading(true);
      clickedSaveBtn = true;
      // refSaveLoading.current = true;
      // sender && sender.set("active");
    //  editor.runCommand("sw-visibility");  //commented this line for-CIA-2405
      try {
        // Refresh Keycloak token before save
        if (keycloak) {
          await keycloak.updateToken(10);
        }
        await editor.store(); // store is now safe
      } catch (err) {
        showErrorToast("Save failed. Please try again.");
      } finally {
        setSaveLoading(false);
      }
      return;
    },
  });

  // editor.Commands.add('image-single-click', {
  //     run(editor, sender, options) {
  //       alert('Image placeholder clicked!');
  //     }
  //   });
//     editor.DomComponents.addType('image', {
//       model: {
//         defaults: {
//           tagName: 'img',
//           // attributes: { src: '' },
//           attributes: { 
//             src: ''  // default placeholder image
//           },
//           style: {
//             width: '450px',  // fixed starting width
//             height: '450px'  // fixed starting height
//           },
//           // Start unlocked
//           resizable: {
//             ratioDefault: false,
//             tl: 0, tr: 0, bl: 0, br: 1 // only bottom-right handle
//           },
    
//           traits: [
//             {
//               type: 'text',
//               name: 'src',
//               label: 'Image URL'
//             },
//             {
//               type: 'checkbox',
//               name: 'keepAspect',
//               label: 'Lock Aspect Ratio',
//               changeProp: 1
//             }
//           ],
    
//           toolbar: [
//             {
//               attributes: { class: 'fa fa-lock' },
//               command: 'toggle-aspect',
//               label: 'Aspect Ratio'
//             },
//             'resizer', // keep default resizer handles
//             'tl', 'tr', 'bl', 'br'
//           ]
//         },
    
//         init() {
//           // React to trait changes
//           this.on('change:keepAspect', () => {
//             const keep = this.get('keepAspect');
//             const resizable = this.get('resizable') || {};
//             this.set('resizable', { ...resizable, ratioDefault: keep });
//           });
//         }
//       }
//     });

//     editor.Components.addType('image-single-click', {
//   // It's a good practice to extend an existing component.
//   extend: 'image',

//   // Define the custom View object.
//   view: {
//     // Override the `events` property to add a `click` listener.
//     // The key is the event name (`click`), and the value is the method to call (`showAssetManager`).
//     events: {
//       'dblclick': 'preventDblclick', // Optional: disable the default double-click behavior
//       'click': 'showAssetManager',
//     },

//     // Define the custom method to execute on a single click.
//     showAssetManager(event) {
//       // Prevent the event from bubbling up to avoid conflicts.
//       event.stopPropagation();
      
//       // Get the Asset Manager and open it.
//       const am = this.em.get('AssetManager');
//       am.open();

//       // Ensure that on selecting an asset, the image component's `src` is updated.
//       am.onSelect(asset => {
//         const selectedComponent = this.model;
//         if (selectedComponent.is('image-single-click')) {
//           selectedComponent.addAttributes({ src: asset.getSrc() });
//         }
//         // Close the asset manager after selection.
//         am.close();
//       });
//     },

//     // Define a method to prevent the default double-click.
//     preventDblclick(event) {
//       event.stopPropagation();
//     }
//   },
// });

  editor.Commands.add("preview", {
    run: async (editor) => {
      setExportLoading(true);
      await editor.store();
      //editor.runCommand("sw-visibility");   //commented this line for-CIA-2405
      let cardDataID = appData?.deckId?._id;
      /* let removeSlide = window.localStorage.getItem("removedSlieId");
      let wrapper = editor.getWrapper().find(`[data-slide-id="${removeSlide}"]`);
      if (wrapper?.length > 0) {
        var comp = editor.getComponents();
        comp.remove(wrapper);
      } */
      ExportDeckToMail(
        cardDataID,
        (response, err, errorCode) => {
          if (err) {
            setExportLoading(false);
            showErrorToast(`Preview Failed. ${err}`);
          } else {
            setExportLoading(false);
            setShowPreView(true);
          }
        },
        "preview=true"
      );
    },
  });
  //Clear Button
  editor.Commands.add("cmd-clear", {
    run: (editor) => {
      editor.DomComponents.clear();
      editor.CssComposer.clear();
    },
  });
  //Undo
  editor.Commands.add("undo", {
    run: (editor) => editor.UndoManager.undo(),
  });
  // Redo
  editor.Commands.add("redo", {
    run: (editor) => editor.UndoManager.redo(),
  });

  editor.Commands.add("export", {
    run: async (editor) => {
      setOpenExportModal(true);
      await editor.store();
     // editor.runCommand("sw-visibility");   //commented this line for-CIA-2405
      // let cardData = JSON.parse(window.localStorage.getItem("edetailData"));
      // setExportLoading(true);

      // ExportDeckToMail(cardData.edetailId, (response, err, errorCode) => {
      //   if (err) {
      //     toast.error(
      //       <div className="">{`Export Failed.. Please Try Again`}</div>,
      //       {
      //         autoClose: 3000,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: false,
      //         progress: undefined,
      //       }
      //     );
      //     setExportLoading(false);
      //   } else {
      //     toast.success(<div className="">{`Link will be mailed`}</div>, {
      //       autoClose: 5000,
      //       progress: undefined,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: false,
      //     });
      //     setExportLoading(false);
      //   }
      // });
    },
    // run: (editor) => editor.runCommand("gjs-export-zip"),
  });
  // Show guides
  editor.Commands.add("visibility", {
    run: (editor) => editor.runCommand("sw-visibility"),
  });
  let error = 0;
  editor.on("storage:error:store", async (err, data) => {
    // showErrorToast('Save failed. Pl try again');
    // setSaveLoading(false);
    error = 1;
  });

  let updateText = document.getElementsByClassName("gjs-toolbar");
  let changeText = document.getElementsByClassName(
    "gjs-rte-toolbar gjs-one-bg"
  );

  editor.on("rte:enable", () => {
    if (changeText && changeText[0]) {
      updateText[0].style.display = "none";
    }
    const comp = editor.getSelected();

    if (comp.get("type") == "link") {
      editor.Canvas.getBody().addEventListener("keydown", (e) => {
        if (e.code === "Space") {
          e.preventDefault();
          e.stopPropagation();
          const selection = e.target.ownerDocument.getSelection();
          selection.deleteFromDocument();
          const emptSpace = "\u00A0";
          selection
            .getRangeAt(0)
            .insertNode(document.createTextNode(emptSpace));
          selection.collapseToEnd();
          return false;
        }
      });
    } else {
      //  editor.Canvas.getBody().removeEventListener("keydown");
    }
  });

  editor.on("rte:disable", () => {
    if (updateText && updateText[0]) {
      updateText[0].style.display = "block";
    }
  });

  // editor.on('rteToolbarPosUpdate', (pos) => {
  //   const blueToolbar = document.querySelector(".gjs-toolbar");
  //   blueToolbar.style.display = "none"
  // });
  editor.on("storage:end:store", () => {
    
    !error &&
      clickedSaveBtn && showSuccessToast('Save successful');
    clickedSaveBtn = false;
    // setSaveLoading(false);
    setDimensionVariable(true);
    
    /* if (localStorage.getItem('SwitchDimen')) {
      editor.load();
      setTimeout(() => {
        localStorage.removeItem('SwitchDimen')
      }, 0);
      
    } */
  });

  let error2;
  editor.on("storage:error:load", () => {
    setSaveLoading(false);
    setLoadSuccess(false);
    error2 = 1;
  });
  editor.on("storage:end:load", () => {
    setSaveLoading(false);

    !error2 && setLoadSuccess(true);
  });
  let lastMousePos = { x: null, y: null };

  let lastHoveredImagePlaceholder = null;

  editor.on("canvas:dragover", (ev) => {
    // Track mouse position for drop positioning
    const cx = (ev && (ev.clientX ?? ev.x ?? (ev.event && ev.event.clientX)));
    const cy = (ev && (ev.clientY ?? ev.y ?? (ev.event && ev.event.clientY)));
    if (typeof cx === 'number' && typeof cy === 'number') {
      lastMousePos.x = cx;
      lastMousePos.y = cy;
    }
    const imageComponents = editor.DomComponents?.getWrapper()?.findType("image");
    if (imageComponents && Array.isArray(imageComponents)) {
      imageComponents.some((imageComponent) => {
        const element = imageComponent?.view?.el;
        if (!element) {
          return false;
        }
        const position = element.getBoundingClientRect();
        const inside =
          typeof cx === "number" &&
          typeof cy === "number" &&
          cx >= position.left &&
          cx <= position.right &&
          cy >= position.top &&
          cy <= position.bottom;
        if (inside) {
          editor.select(imageComponent);
          lastHoveredImagePlaceholder = imageComponent;
        }else {
          // editor.select();
          // lastHoveredImagePlaceholder = null;
        }
      });
    }
    window.localStorage.setItem("drop", true);
    editor.select(null);
  });

  editor.on('block:drag:start', ( _, element ) => {
    element.dataTransfer.setDragImage(element.srcElement, 0, 0);
  });
  
  editor.on("component:selected", (component) => {
    const checkCurrentStatus = editor.UndoManager.hasUndo();
    if (checkCurrentStatus) {
      setRedoCurrentStatus((prevState) => checkCurrentStatus);
    }
  });

  editor.on("component:toggled", () => {
    //Hides General and Typography on wrapper selection
    hideGeneralAndTopographyForWrapper(editor);
  });

  let dragedComponentIsImage = false;

  editor.on("component:selected", (component) => {
    const tagNameForm = [
      "input",
      "textarea",
      "label",
      "button",
      "select",
      "form",
    ];

    if (component.is('image')) {
      
   
      const cmp = editor.getSelected();
      cmp.getEl().addEventListener('drop', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const dt = event.dataTransfer;
        const json = dt.getData('application/json');
        if(!json) {
          dragedComponentIsImage = false;
          return;
        } else {
          dragedComponentIsImage = true;
        }
        const images = JSON.parse(json);
         cmp && cmp.set({ src: images, alt: "ImageName"});
    
      });
          if(component.attributes.tagName === "img") {
           setState(true)
           editor?.AssetManager?.open();

         
        } 
    }

    if (component.is('video')) {
      const cmp = editor.getSelected();
      if (!cmp) return;

      const el = cmp.getEl();
      if (!el) return;

      cmp.getEl().addEventListener('drop', (event) => {
        event.preventDefault();
        const dt = event.dataTransfer;
        const json = dt.getData('application/json');
        const videoData = JSON.parse(json);
        cmp.set({ src: videoData.link });
      });
    }

    
    trackDroppingComponent(component, setVideoSelected, setExpandLeft, setExpandRight, editor)

    //body tag doesn't have modular content toggle
    //hideModularContentForBodyTag(component);

    //Modular content toggle show for component 
    //modularContentToggleShow(component, tagNameForm, switchToggleDataRef, editor);
    //left blocks show rspect to comp
    leftPanelBlocksHideShow(editor, component, tagNameForm)

    //set image upload setion false/hide
    // setState(false);
    if (component.is('image')) {
     // setState(true);
      const pn = editor?.Panels;
      const traitBtn = pn?.getButton('views', 'open-tm');
      if(traitBtn && !traitBtn?.get('active')) {
        traitBtn?.set('active', true);
        pn?.trigger('change:active', traitBtn);
      }
    } else {
       if (editor?.AssetManager) {
      setState(false);
      editor?.AssetManager?.close();
    }
     // setState(false);
    }
    showSlidesPanel(false);

    //configs for comp selection respectively
    onCompSelectConfig(component, editor)

    // }
  });

  // table traits setting for preventing negative numbers for rows and columns
  tableConfig(editor);

  //video component default collapsed all properties
  videoConfig(editor)
  //end

  function getTraitsOptionsStructure(show, slideListName) {

    const { _id, name } = show.slideid;
    let ID = JSON.stringify(currentSlideRef?.current?.child) === "{}"
      ? currentSlideRef?.current?.master?.slideid?._id
      : currentSlideRef?.current?.child?.slideid?._id;
   
      const allIds = [];

      // const walk = (comps) => {
      //   comps.each((child) => {
      //     const id = child.getAttributes()?.id;
      //   //  console.log(child.get("type"), "here")
      //     if (id && child.get("type") === "custom-popup") {
      //       allIds.push(id); 
      //     }
      //     if (child.components().length) walk(child.components());
      //   });
      // };

      // walk(editor.DomComponents.getComponents());
      allIds.forEach((id) => {slideListName.push({ id, name: id })})
    if (ID !== _id)
      slideListName.push({ id: _id, name })
    if (ID === _id && show.children.length) {
      show.children.forEach((child) => {
        const { _id, name } = child.slideid;
        slideListName.push({ id: _id, name })
      })
    }
  }

  function isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

  const updateStyleManager = () => {
    const model = editor.getSelected();
    const sm = document.getElementsByClassName("gjs-sm-sectors")[0];
    sm.style.display = model?.attributes?.type === "wrapper" ? "none" : "block";
  };

  //Common trait for every component act as popup trigger
  defaultConfigForAllComp(editor)


  editor.on("component:remove:before", function (elem) {
    setVideoSelected(false);
    if (elem.attributes.tagName !== "body") {
      // after deleting comp redirect to block list comp
      if (appData.deckId.default_aspect_ratio !== selectedItem)
        setListOfID([...listOfIDRef.current, elem.ccid]);

      setState(false);
      //Removing comp should retain to default editor screen
      removeCompSettingRetainDefault(editor)

      //find dataId for popup modal reference to remove corresponding div while removing comp has link with subslide
      //delete linked modal if respective component deleted
      removePopupDivLinkedToComp(elem, editor)
    }
  });

  editor.on("component:selected", function (elem) {
    //change of video src trigger this function
    elem.on("change:src", function () {
      const attr = this?.attributes?.src;
      const availaleExtensions = ["mp4", "webm", "ogv"];
      const extn = attr?.split(".").reverse()[0];
      //const regx = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/igm;
      if (
        this.attributes.provider === "so" &&
        availaleExtensions.includes(extn) &&
        this.attributes.type === "video"
      ) {
        if (isValidHttpUrl(attr)) {
        } else {
          showErrorToast('Please provide correct URL.');
        }
      } else if (this.attributes.provider === "yt") {
        // this.get("traits").where({ name: "videoId" })[0].set("value", "");
      } else if (this.attributes.provider === "ytnc") {
        // this.get("traits").where({ name: "videoId" })[0].set("value", "");
      } else if (this.attributes.provider === "vi") {
        // this.get("traits").where({ name: "videoId" })[0].set("value", "");
      } else {
        // if (attr !== "" && this.attributes.type === "video") {
        //   showErrorToast(`Please provide only 'mp4', 'webm' 'ogv' extensions`);
        // }
      }
    });
    //change of video provider trigger this function
    elem.on("change:provider", function () {
      if (this.attributes.provider === "so") {
        this.get("traits").where({ name: "controls" })[0].set("value", false);
        this.get("traits").where({ name: "controls" })[0].set("value", true);
      } else {
        /* setTimeout(() => {
          //this.get("traits").where({ name: "videoId" })[0].set("value", " ");
          this.get("traits").where({ name: "videoId" })[0].set("value", "");
        }, 500); */
        this.set({ videoId: "" });
      }
    });

    // binding event on link to selection
    elem.on("change:attributes:data-slide-id", function (val) {

      if (val?.attributes?.attributes["data-slide-id"] === 'null') {
        elem.removeAttributes("data-slide-id");
        return;
      }

      let valMaster = attachMasterSlide(elem, appData, editor, currentSlideRef, val?.attributes?.attributes["data-slide-id"])
      if (!valMaster) {
        return
      }
      //elem.removeTrait("href");
      const attrList = this.getAttributes();
      this.addAttributes({ ccid: this.ccid });
      const dataId =
        this.attributes.tagName === "img" ? this.ccid : attrList["id"];
      var ele = editor.getWrapper()?.find(`[data-id= ${dataId}]`);
      var bodyElem = editor.getWrapper();
      if (ele.length === 0) {
        bodyElem.append(`<div data-id='${dataId}' data-slide-id='${attrList["data-slide-id"]}' class="modal">
         <div class="modal-content">
         <span class="close"><button style="cursor:pointer">&times;</button></span>
         </div>
       </div>`);
      } else {
        var comp = editor.getComponents();
        comp.remove(ele);
        bodyElem.append(`<div data-id='${dataId}' data-slide-id='${attrList["data-slide-id"]}' class="modal">
         <div class="modal-content">
         <span class="close"><button style="cursor:pointer">&times;</button></span>
         </div>
       </div>`);
      }
    });

    // end binding linkto selection event

    const childrenList = currentSlideRef?.current?.master?.children?.length;
    if (
      elem.attributes.tagName !== "body" &&
      elem.attributes.name !== "Wrapper"
    ) {
      const childId = currentSlideRef.current.child?.slideid?._id
        ? currentSlideRef.current.child?.slideid?._id
        : "";
      // const slidesList = currentSlideRef.current.master.children.map(
      //   getTraitsOptionsStructure
      // );
      // const linkToList = slidesList.filter((list) => list.id !== childId);


      let linkToList = [{ id: null, name: 'No Link' }]
      appData.deckId.slides.forEach((show) => {

        getTraitsOptionsStructure(show, linkToList)
      });
      // redeclare trait again after removing
      if (
        elem.get("traits").where({ name: "data-slide-id" }).length === 0 &&
        elem.attributes.tagName !== "body"
      ) {
        if (
          elem.attributes.type !== "link"
          //&&
          // hrefLinked?.trim() !== "" &&
          // hrefLinked?.trim() !== undefined
          && elem.attributes.tagName !== "a" && elem.attributes.type !== "text"
          && elem.attributes.type !== "popup-close-button"
          && elem.attributes.type !== "popup-trigger-button"
        ) {
          elem.get("traits").add({
            type: "select",
            label: "Link To",
            name: "data-slide-id",
          });
        }
      }
      //
      if (elem.get("traits").where({ name: "data-slide-id" }).length > 0) {
        elem
          .get("traits")
          .where({ name: "data-slide-id" })[0]
          .set("options", linkToList);
      }
      //if slide doesn't have any children
      // if (childrenList === 0) {
      //   elem.removeTrait("data-slide-id");
      // }
      // if only one subslide is there then subslide should not show linkTo
      if (linkToList.length === 0) {
        elem.removeTrait("data-slide-id");
      }
      // link to should not be available to subslides
      if (
        childId !== "" &&
        childId !== currentSlideRef?.current?.master?.slideid._id
      ) {
        elem.removeTrait("data-slide-id");
      }
      elem.on("change:attributes:href", function (val) {
        const href = val.attributes?.attributes["href"];
        if (
          elem.attributes.type === "link"
          // &&
          // href?.trim() !== "" &&
          // href !== undefined
        ) {
          elem.removeTrait("data-slide-id");
        }
        if (
          elem.get("traits").where({ name: "data-slide-id" }).length === 0 &&
          (href === "" || href === undefined)
        ) {
          elem.addTrait({
            type: "select",
            label: "Link To",
            name: "data-slide-id",
            options: linkToList,
          });
        }
      });
    }
  });

  editor.on("component:selected", updateStyleManager);

  editor.on("component:clone", function (elem) {
    if (appData.deckId.default_aspect_ratio !== selectedItem)
      setListOfID([...listOfIDRef.current, elem.ccid]);
    // const attr = elem.getAttributes();

    /* const attr = elem.getAttributes();
    delete attr["data-slide-id"];
    delete attr["ccid"];
    elem.setAttributes(attr);
    elem.removeTrait("data-slide-id"); */

  });

  editor.on("component:update:attributes", updateStyleManager);
  editor.on('canvas:drop', (ev,component)=>{
      // Position component at mouse cursor using translate
      if (lastMousePos.x !== null && lastMousePos.y !== null) {
        setTimeout(() => {
          try {
            const el = component.getEl && component.getEl();
            const frame = editor.Canvas && editor.Canvas.getFrameEl && editor.Canvas.getFrameEl();
            if (!el || !frame) return;

            const frameRect = frame.getBoundingClientRect();
            const cursorXInFrame = lastMousePos.x - frameRect.left;
            const cursorYInFrame = lastMousePos.y - frameRect.top;

            const parent = el.offsetParent || el.parentElement;
            if (!parent) return;
            const parentRect = parent.getBoundingClientRect();
            const parentLeftInFrame = parentRect.left - frameRect.left;
            const parentTopInFrame = parentRect.top - frameRect.top;

            // Calculate desired position relative to parent
            const desiredLeft = cursorXInFrame - parentLeftInFrame;
            const desiredTop = cursorYInFrame - parentTopInFrame;

            // Get current element position
            const currentLeft = el.offsetLeft || 0;
            const currentTop = el.offsetTop || 0;

            // Calculate translate delta
            const deltaX = desiredLeft - currentLeft;
            const deltaY = desiredTop - currentTop;

            // Get existing translate if any
            const computedStyle = window.getComputedStyle(el);
            const transform = computedStyle.transform;
            let baseTx = 0, baseTy = 0;
            
            if (transform && transform !== 'none') {
              const matrix = new DOMMatrix(transform);
              baseTx = matrix.e;
              baseTy = matrix.f;
            }

            // Ensure parent is positioned for absolute children
            const parentStyle = window.getComputedStyle(parent);
            if (parentStyle.position === 'static') {
              const parentModel = component.parent && component.parent();
              if (parentModel && parentModel.addStyle) {
                parentModel.addStyle({ position: 'relative' });
              }
            }

            // Apply new translate and set absolute to remove from flow (siblings won't move)
            const newTx = Math.round(baseTx + deltaX);
            const newTy = Math.round(baseTy + deltaY);
            component.addStyle({ 
              position: 'absolute',
              transform: `translate(${newTx}px, ${newTy}px)` 
            });
          } catch (_) {}
        }, 0);
      } 
      if (lastHoveredImagePlaceholder && dragedComponentIsImage ) {
        setTimeout(() => {
          const style = lastHoveredImagePlaceholder.getStyle();
          console.log(style);
          delete style?.height;
          lastHoveredImagePlaceholder.setStyle({
            ...style,
            height: "auto",
          });
          console.log(lastHoveredImagePlaceholder.getStyle());
          editor.select(lastHoveredImagePlaceholder);
          dragedComponentIsImage = false;
        }, 100);
      }
  })
  editor.on(`block:drag:stop`, (component, block) => {
    // if component exists, means the drop was successful
    // window.localStorage.setItem("drop", true);
    editor?.SelectorManager?.setState("");
    if (component) {
      // Since the comp inside the link was not getting highlighted, this is workaround
      // Do you need the parent who contains this new added component??

      if (component.parent().attributes.type === "link") {
        editor.select(component);

        if (component.attributes.type === "link") {
          component.parents().forEach((comp) => {
            if (comp.attributes.name === "Link Block") component.remove();
          });
          const structureBlock = document.querySelector(
            ".gjs-block-categories"
          ).firstChild;
          structureBlock?.classList.add("d-none");
          structureBlock?.classList.remove("d-block");
        }
      }

      window.localStorage.setItem("drop", false);
      // setState(false);
      editor.select(null);

      if (appData.deckId.default_aspect_ratio !== selectedItem && selectedItem)
        setListOfID([...listOfIDRef.current, component.ccid]);
      if (component.getName() === "tabs")
        setListOfID([...listOfIDRef.current, "tab", "tab-contents", "tab-container"]);

     
    }

    Flag = true;

  });

  EditorOnLoad({ editor, setVideoSelected, setUploadFont, appData, setOpenDocumentModal, setState, selectedItem, storageObjRef, currentSlideRef, codeEditor, setLoading })
  editor.Components.addType("Div", {
    isComponent: (el) => {
      return (
        el.tagName === "Div" &&
        el.getAttribute("data-gjs-type") === "Div" &&
        el.getAttribute("data-gjs-name") === "Div"
      );
    },

    extend: "default",

    model: {
      defaults: {
        tagName: "Div",
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
      },
    },
  });


  editor.RichTextEditor.add("orderedList", {
    icon: "",
    attributes: { title: "Ordered List", class: "gjs-rte-action ordered-list" },
    result: (rte) => {
      const rteEl = editor.RichTextEditor.getToolbarEl();
      rteEl.firstChild.childNodes.forEach((child, idx) => { });
      rte.exec("insertOrderedList");
    },
  });

  editor.RichTextEditor.add("unorderedList", {
    icon: "",
    attributes: {
      title: "Unordered List",
      class: "gjs-rte-action unordered-list",
    },
    result: (rte) => rte.exec("insertUnorderedList"),
  });

  editor.RichTextEditor.add("superscript", {
    icon: "<b>S<sup>s</sup></b>",
    attributes: { title: "Superscript" },
    result: (rte) => rte.exec("superscript"),
  });

  editor.RichTextEditor.add("subscript", {
    icon: "<b>S<sub>s</sub></b>",
    attributes: { title: "Subscript" },
    result: (rte) => rte.exec("subscript"),
  });

  // editor.on("load", (elem) => {
  //   const allComponents = editor.DomComponents.getComponents();
  //   const formsFieldsBlock = document?.querySelector(".forms-field-block");
  //   const traverseComponents = components => {
  //     components.forEach(comp => {
  //       if (comp.is('form')) {
  //         formsFieldsBlock?.classList.add("form-fields-active");
  //       }
  //       else if (comp.components && comp.components().length) {
  //         traverseComponents(comp.components());
  //       }
  //     });
  //   };
  //   traverseComponents(allComponents);
  // });

  // editor.on("update", (elem) => {
  //   const allComponents = editor.DomComponents.getComponents();
  //   const formsFieldsBlock = document?.querySelector(".forms-field-block");
  //   const traverseComponents = components => {
  //     components.forEach(comp => {
  //       if (comp.is('form')) {
  //         formsFieldsBlock?.classList.add("form-fields-active");
  //       }
  //       else if (comp.components && comp.components().length) {
  //         traverseComponents(comp.components());
  //       }
  //     });
  //   };
  //   traverseComponents(allComponents);
  // });
  editor.DomComponents.addType('image', {
      model: {
        defaults: {
          tagName: 'img',
          attributes: { src: '' },
          // style: {
          //   width: '450px',
          //   height: '450px',
          //   maxWidth: 'auto',
          //   maxHeight: 'auto'
          // },

          resizable: false, // Default: not resizable until checkbox is checked
          lockAspectRatio: false,
          aspectRatio: null, // Will store the calculated aspect ratio

          traits: [
            {
              type: 'text',
              name: 'src',
              label: 'Image URL'
            },
            {
              type: 'checkbox',
              name: 'lockAspectRatio',
              // name: 'keepAspect',
              label: 'Lock Aspect Ratio',
              changeProp: 1
            }
          ],
        },

        init() {
          this.listenTo(this, 'change:lockAspectRatio', this.toggleResizable);
          this.listenTo(this, 'change:attributes:src', this.calculateAspectRatio);
          this.addLockIconToToolbar();
          
          // Calculate aspect ratio if src already exists
          const src = this.getAttributes().src;
          if (src) {
            this.calculateAspectRatio();
          }
        },

        calculateAspectRatio() {
          const src = this.getAttributes().src;
          if (!src) return;

          const img = new Image();
          img.onload = () => {
            const isLocked = this.get('lockAspectRatio');
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            this.set('aspectRatio', aspectRatio);
            // If aspect ratio is locked, update resizable config
            if (this.get('lockAspectRatio')) {
              this.updateResizableConfig();
            }
              aspectRatioCheckBoxHandler(isLocked);
          };
          img.onerror = () => {
            // If image fails to load, try to get aspect ratio from element
            const el = this.getEl();
            if (el && el.naturalWidth && el.naturalHeight) {
              const aspectRatio = el.naturalWidth / el.naturalHeight;
              this.set('aspectRatio', aspectRatio);
            }
          };
          img.src = src;
        },

        updateResizableConfig() {
          const isLocked = this.get('lockAspectRatio');
          const aspectRatio = this.get('aspectRatio');

          if (isLocked && aspectRatio) {
            this.set('resizable', {
              tl: 1, tc: 0, tr: 1,
              cl: 0, cr: 0,
              bl: 1, bc: 0, br: 1,
              ratioDefault: true,
              ratio: aspectRatio
            });
          } else {
            this.set('resizable', {
              tl: 1, tc: 1, tr: 1,
              cl: 1, cr: 1,
              bl: 1, bc: 1, br: 1,
              ratioDefault: false
            });
          }
          // Update toolbar icon based on lock state
          aspectRatioCheckBoxHandler(isLocked);
        },

        addLockIconToToolbar() {
          const toolbar = this.get('toolbar') || [];
          const isLocked = this.get('lockAspectRatio');
          const hasLockIcon = toolbar.some(t => t.command === 'toggle-aspect');
        
          if (!hasLockIcon) {
            // Enable resizable if not locked
            if (!isLocked) {
              this.updateResizableConfig();
            } else {
              this.updateResizableConfig();
            }
            
            const lockBtn = {
              id: 'lock-btn',
              type: 'button',
              command: 'toggle-aspect',
              attributes: {
                class: 'gjs-toolbar-item',
                title: 'Lock Aspect Ratio'
              },
              label: isLocked
                ? `<img src="${LockIcon}" style="width:16px;height:16px;" />`
                : `<img src="${UnlockIcon}" style="width:16px;height:16px;" />`
            };

            this.set('toolbar', [lockBtn, ...toolbar]);
          }
        },
        toggleResizable() {
          const isLocked = this.get('lockAspectRatio');
          const toolbar = this.get('toolbar') || [];
          const updatedToolbar = toolbar.map(item => {
            if (item.command === 'toggle-aspect') {
              return {
                ...item,
                label: isLocked
                ? `<img src="${LockIcon}" style="width:16px;height:16px;" />`
                : `<img src="${UnlockIcon}" style="width:16px;height:16px;" />`
              };
            }
            return item;
          });
          this.set('toolbar', updatedToolbar);
          
          // Update resizable configuration
          this.updateResizableConfig();
        }
      }
    });

    editor.on('asset:add', (asset) => {
      setTimeout(() => {
        const selected = editor.getSelected();
        if (
          selected &&
          selected.is('image') &&
          !selected.getAttributes()['data-placeholder']
        ) {
          // Calculate aspect ratio when image is added
          if (selected.calculateAspectRatio) {
            selected.calculateAspectRatio();
          }
          
          selected.addStyle({
            width: 'auto',
            height: 'auto'
          });

          // Clean any fixed dimensions if they exist
          selected.removeStyle('width');
          selected.removeStyle('height');
        }
      }, 100);
    });
    
    // Command for toggling aspect ratio via toolbar button
    editor.Commands.add('toggle-aspect', {
      run(ed, sender) {
        const cmp = ed.getSelected();
        if (!cmp || !cmp.is('image')) return;
    
        const isLocked = !cmp.get('lockAspectRatio');
        cmp.set('lockAspectRatio', isLocked);
        
        // Update resizable configuration
        if (cmp.updateResizableConfig) {
          cmp.updateResizableConfig();
        }
        
        // Update button active state
        if (sender) {
          sender.set('active', isLocked);
        }
      }
    });

  editor.on("component:selected", (elem) => {
    const selected = editor.getSelected();
    opacityFieldRestrictDecimal();
    linkComponent(selected, elem);
    tableRowColumnDecimalRestriction(selected);
    
    // Calculate aspect ratio when image is selected if it has a src
    if (selected && selected.is('image')) {
      const src = selected.getAttributes().src;
      if (src && selected.calculateAspectRatio) {
        selected.calculateAspectRatio();
      }
    }
  });
  
  // Maintain aspect ratio during resize
  editor.on('component:update', (component) => {
    if (component && component.is('image') && component.get('lockAspectRatio')) {
      const aspectRatio = component.get('aspectRatio');
      if (aspectRatio) {
        const el = component.getEl();
        if (el) {
          const currentWidth = parseFloat(el.style.width) || el.offsetWidth;
          const currentHeight = parseFloat(el.style.height) || el.offsetHeight;
          
          // If width changed, update height to maintain aspect ratio
          if (currentWidth && currentHeight) {
            const expectedHeight = currentWidth / aspectRatio;
            if (Math.abs(currentHeight - expectedHeight) > 1) {
              component.addStyle({ height: `${expectedHeight}px` });
            }
          }
        }
      }
    }
  });

  editor.on("component:selected", (elem) => {
    const selected = editor.getSelected();
    opacityFieldRestrictDecimal();
    linkComponent(selected, elem);
    tableRowColumnDecimalRestriction(selected);

  });

  editor.on("component:deselected", (component) => {
    //called on deselection of component, gets previous comp on selection of next comp
    callbackOnDeselectOfComp(component, setState, editor)
  });

  //chngs made by Siva for dimen story
  editor.on("component:remove:before", (component) => {
    if(selectedItem) {
      const id = component.ccid;
      let allDimensions = Object.entries(cssRef.current).reduce((accumulator, [dim, dimObj]) => {
        
        accumulator[dim] = dimObj.filter((element) => {
          if(element.id !== id) {
            return element;
          }
          storageObjRef.current[dim] = {
            ...storageObjRef.current[dim],
            cssObj: storageObjRef.current[dim]?.cssObj?.filter(el => el.id !== id)
          }
        });
        return accumulator;
      }, {});
      
      setCSSState(allDimensions)
      cssRef.current = allDimensions;
    }
  })
 


  return editor;
}
// const updateModularContenforMM = (editor, ID) => {
//   const modBlockIndex = editor?.getWrapper()?.find("[modularBlockIndex]")?.length;
//   const modBlockRef = editor
//     ?.getWrapper()
//     .find("[modularblock=reference]").length;

//   const ModuleArray = [
//     "Module_A",
//     "Module_B",
//     "Module_C",
//     "Module_D",
//     "Module_E",
//     "Module_F",
//     "Module_G",
//   ];

//   ModuleArray.length = modBlockIndex;
//   if (modBlockRef > 0) {
//     ModuleArray.push("Module_Ref");
//   }

//   // if ( JSON.stringify(appData.) === JSON.stringify(ModuleArray))
//   // return;
//   updatSlideData(
//     ID,
//     { modules_tags: ModuleArray },
//     (response, err, errorCode) => {
//       if (err) {
//       } else {
//       }
//     }
//   );
// };

const constructCSS = (cssRef, dim, editor) => {

  let cssString = "";
  [...cssRef.current[dim]].forEach((obj) => {

    let idName = "", newObj = {};

    for (let key in obj) {

      if (key === "id") {

        idName = "#" + obj[key];

      } else {

        newObj[key] = obj[key];

      }
    }

    cssString = cssString + idName + (JSON.stringify(newObj)
      .replace(/,/g, ';')            // Replace commas with semicolons
      .replace(/"/g, '')             // Remove quotes around keys and values
      .replace(/:/g, ': '))
    cssString = cssString
  })
  //  editor.setStyle(cssString);

  return cssString;
}

const savingResponsiveData = ({ storageObjRef, appData, selectedItem, cssRef, editor, data, setStorageObj }) => {
  if (!storageObjRef.current) {
    return data
  }
  let content = {};
  let defaultCSS = appData.deckId.default_aspect_ratio === selectedItem ? editor?.getCss() : storageObjRef?.current?.css;
  let LocalEditorData = appData.deckId.default_aspect_ratio === selectedItem ? JSON.stringify(data) : (storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData) ? storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData : "";
  content = {
    ...storageObjRef.current,
    default_ratio: appData.deckId.default_aspect_ratio,
    [selectedItem]: {
      editorData: JSON.stringify(data),
      // Preserve existing CSS data if cssRef is empty but storageObj has data
      cssObj: (() => {
        const cssRefData = cssRef.current[selectedItem];
        const storageData = storageObjRef.current && storageObjRef.current[selectedItem]?.cssObj;
        
        // console.log(`CSS Save Debug for ${selectedItem}:`, {
        //   cssRefHasData: cssRefData && cssRefData.length > 0,
        //   cssRefLength: cssRefData ? cssRefData.length : 0,
        //   storageHasData: !!storageData,
        //   storageLength: storageData ? storageData.length : 0
        // });
        
        if (cssRefData && cssRefData.length > 0) {
          // console.log("Using cssRef data");
          return cssRefData;
        } else if (storageData && storageData.length > 0) {
          // console.log("Using storage data as fallback");
          return storageData;
        } else {
          // console.log("No CSS data available, using empty array");
          return [];
        }
      })(),
      css: `${constructCSS(cssRef, selectedItem, editor)}`
      //  ratio_css: cssRef.current[dim]

    },
    //editorData: storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData|| JSON.stringify(data) ||"",
    editorData: LocalEditorData,
    html: editor?.getHtml() || "",
    css: `@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
${defaultCSS}`,
    extraContent:getPopUp(editor),

    // components: editor.getComponents() || "",
    // styles: editor.getStyle() || "",
    scripts: script,
      // editor?.getWrapper()?.find("[ccid]").length > 0
      //   ? script
      //   : mandatScript,
    thirdPartyPlugins: thirdPartyPlugins,

    //modalBgColor: editor.getWrapper().getStyle()["background-color"],
  };

  return content;
}

const getPopUp =(editor) =>{
    const allPopups = [];
    editor?.getWrapper()?.findType('custom-popup')?.forEach(comp => {
      const compId = comp?.ccid;
      allPopups.push({html:(comp.toHTML()), id: compId});
      // allPopups.push(comp.toHTML());
    });
  return allPopups;
}
export default getGrapeJsEditor;
